import { Injectable } from '@angular/core';
import { ChartViewDTO } from '../model/chart_view/chart-view-dto';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { QuantiteDossierPortefeuilleParProduitDTO } from '../model/quantite-dossier-portefeuille-par-produit-dto';
import { DurationByProduitDTO } from '../model/duration-by-produit-dto';
import { DurationByTaskDTO } from '../model/duration-by-task-dto';
import { SlaProduitDTO } from '../model/sla-produit-dto';
import { ProductiviteByProfileDTO } from '../model/productivite-by-profile-dto';
import { QuantiteDossierByEmployeeDTO } from '../model/quantite-dossier-by-employee-dto';

@Injectable({
    providedIn: 'root'
  })
export class DashboardAllDirectionService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    
    
    montantDossierStatutSurLes6DerniersMois(codedirection) 
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-all-direction/montant-dossier-statut-sur-les-6-derniers-mois?codedirection='+codedirection);
    }

    quantiteDossierStatutSurLes6DerniersMois(codedirection) 
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-all-direction/quantite-dossier-statut-sur-les-6-derniers-mois?codedirection='+codedirection);
    }
    
    quantiteDossierPortefeuilleParProduit(codedirection) 
    {
        return this._restClientService.load<QuantiteDossierPortefeuilleParProduitDTO[]>('dashboard-all-direction/quantite-dossier-portefeuille-par-produit?codedirection='+codedirection);
    }
    
    durationProduit(codedirection) 
    {
        return this._restClientService.load<DurationByProduitDTO[]>('dashboard-all-direction/duration-produit?codedirection='+codedirection);
    }
    
    durationTask(codedirection, codeProduit) 
    {
        return this._restClientService.load<DurationByTaskDTO[]>('dashboard-all-direction/duration-task?codeProduit='+codeProduit+'&codedirection='+codedirection);
    }
    
    slaProduit(codedirection) 
    {
        return this._restClientService.load<SlaProduitDTO[]>('dashboard-all-direction/sla-produit?codedirection='+codedirection);
    }
    
    dossierPeriodeParProfile(codedirection) 
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-all-direction/dossier-periode-par-profile?codedirection='+codedirection);
    }
    
    productiviteByProfile(codedirection) 
    {
        return this._restClientService.load<ProductiviteByProfileDTO[]>('dashboard-all-direction/productivite-by-profile?codedirection='+codedirection);
    }
    
    quantiteDossierByEmployee(codedirection) 
    {
        return this._restClientService.load<QuantiteDossierByEmployeeDTO[]>('dashboard-all-direction/quantite-dossier-by-employee?codedirection='+codedirection);
    }

    slaPeriodeParProduit(codedirection) 
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-direction-juridique/sla-periode-par-produit?codedirection='+codedirection);
    }
    
    slaPeriodeParProfile(codedirection) 
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-direction-juridique/sla-periode-par-profile?codedirection='+codedirection);
    }
    

    
}